import * as api from '../../services/onlineUser'

export const FETCH_ONLINE_USERS = 'FETCH_ONLINE_USERS';
export const FETCH_ONLINE_USER_TOKENS = 'FETCH_ONLINE_USER_TOKENS';
export const FETCH_ONLINE_USER_COUNT_STATS = 'FETCH_ONLINE_USER_COUNT_STATS';


export const fetchOnlineUserTokens = (userId) => {
    return {
        type: FETCH_ONLINE_USER_TOKENS,
        payload: {
            promise: api.findOnlineUserTokens({userId: userId})
        }
    }
};

export const fetchOnlineUserCountStats = () => ({
    type: FETCH_ONLINE_USER_COUNT_STATS,
    payload: {
        promise: api.findOnlineUserCountStats()
    }
});

export const fetchOnlineUsers = (params, pagination, sort, extra) => {

    return {
        type: FETCH_ONLINE_USERS,
        payload: {
            promise: api.findOnlineUsers(Object.assign({}, params, {page: pagination ? pagination.current : 1, pageSize: pagination ? pagination.pageSize : 20})),
        },
        meta: {
            searchParams: params,
            sort: sort,
            extra: extra
        }
    };
};



// WEBPACK FOOTER //
// ./src/redux/actions/onlineUser.js